import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { WorkPermitEventType } from "@/model/Enums";

export interface IWorkPermitEvent {
    whoID: string;
    who: string;
    what: WorkPermitEventType;
    when: Date;
    info: string;
}

export class WorkPermitEvent implements IWorkPermitEvent {

    constructor(data?: IWorkPermitEvent) {
        if (data) this.update(data);
    }

    update(data: IWorkPermitEvent): WorkPermitEvent {
        mapData(data, {
            root: () => this
        });
        return this;
    }

    whoID: string = ""; // email or user ID
    who: string = "";
    what: WorkPermitEventType = WorkPermitEventType.None;
    when: Date = new Date(Utils.emptyDateValue);
    info: string = "";

    get whatText(): string {
        if(!Utils.isEmptyOrWhitespace(this.info)) return this.info;
        const text = Utils.camelCaseAddSpaces(WorkPermitEventType[this.what]);
        if(!text) return `??? ${this.what}`;
        return text.replace("Expired", "(Expired)"); // + " - " + this.what ;
    }

    get isStatus(): boolean {
        return this.what > WorkPermitEventType.None && this.what <= WorkPermitEventType.Closed;
    }
}
